import ViewPortUtil from '@/core/utils/viewport/viewportUtil';
import AppStateModel from '@/app/model/appStateModel';
import ContentModel from '@/app/model/contentModel';
import LogUtil from '@/core/utils/logUtil'
import { OGMetaTags } from '@/core/utils/sharingDataUtil'

// should match content.json keys under "sharing"
const _FACEBOOK = 'facebook';
const _X = 'x';
const _LINKEDIN = 'linkedin';

export default class Sharer {
    static data: any;
    static OGmetaTags: OGMetaTags;
    static _active: boolean;

    static init(OGmetaTags: OGMetaTags, isActive = false) {

        Sharer.data = ContentModel.instance.getShareData();

        Sharer.OGmetaTags = OGmetaTags;
        Sharer.isActive = isActive;
    }

    static _getWindowSpec(tgt: SharingTarget) {

        // add platform-default for when no breakpoint is specified in content.json
        let specString = tgt.window.default || '';

        for (let breakpoint of AppStateModel.breakpoints) {

            if (breakpoint === ViewPortUtil.breakpoint) {

                specString = tgt.window[breakpoint] || '';
            }
        }
        return specString;
    }

    static showPopupMsg(parent: HTMLElement, msg: string) {
        // Create popup element
        const popup = document.createElement('div');
        popup.textContent = msg;
        popup.style.cssText = `
                position: absolute;
                background: rgba(0, 0, 0, 0.5);
                color: white;
                padding: 2px 8px;
                border-radius: 4px;
                font-size: 12px;
                pointer-events: none;
                transform: translateX(-50%);
                bottom: 100%;
                left: 50%;
                margin-bottom: 8px;
                white-space: nowrap;
            `;

        parent.style.position = 'relative';
        parent.appendChild(popup);

        // Remove after delay
        setTimeout(() => {
            parent.removeChild(popup);
        }, 1500);
    }


    // deprecated - do not use
    static shareToClipboard(shareButton: HTMLElement) {
        const baseUrl = Sharer.OGmetaTags.url.getAttributeNode('content')?.value;
        const stateParams = AppStateModel.getStateQueryString(false);
        const shareURL = `${baseUrl}?${stateParams}`;

        // Copy to clipboard using the Clipboard API
        navigator.clipboard.writeText(shareURL)
            .then(() => {
                Sharer.showPopupMsg(shareButton, 'Link kopiert!');
            })
            .catch(() => {
                LogUtil.error('Failed to copy URL to clipboard');
            });
    }

    static shareToLinkedin() {
        // start of share-request string
        let url = '?';

        // add 1st param: url
        url += 'url=' + encodeURIComponent(Sharer.OGmetaTags.url.getAttributeNode('content')?.value ?? '');
        // append model query-string to the url:
        url += '?' + encodeURIComponent(AppStateModel.getStateQueryString());


        // open new window/tab with sharing url in it
        const tgt = Sharer.getTarget(_LINKEDIN)
        if (tgt) {
            window.open(tgt.endpoint + url, '_blank', Sharer._getWindowSpec(tgt));
        } else {
            LogUtil.error('sharing target not found')
        }
    }

    // deprecated - do not use
    //static shareToTwitter() {}
    /*static shareToFacebook() {
        // start of share-request string
        let url = '?';

        // add 1st param: url
        url += 'u=' + encodeURIComponent(Sharer.OGmetaTags.url.getAttributeNode('content').value);
        // append model query-string to the url:
        url += '?' + encodeURIComponent(AppStateModel.getStateQueryString());


        // add 2nd param: title
        url += '&title=' + encodeURIComponent(Sharer.OGmetaTags.title.getAttributeNode('content').value);


        // add 3rd param: description
        url += '&description=' + encodeURIComponent(Sharer.OGmetaTags.description.getAttributeNode('content').value);


        // add 4th param: picture
        url += '&picture=' + encodeURIComponent(Sharer.OGmetaTags.image.getAttributeNode('content').value);


        // open new window/tab with FB sharer.php in it
        const tgt = Sharer.getTarget(_FACEBOOK)
        if (tgt && tgt.name === _FACEBOOK) {
            window.open(tgt.endpoint + url, '_blank', Sharer._getWindowSpec(tgt));
        } else {
            LogUtil.error('sharing target not found')
        }
    }*/

    static shareToX() {
        // start of share-request string
        let url = '?';

        // add url
        url += 'url=' + encodeURIComponent(Sharer.OGmetaTags.url.getAttributeNode('content')?.value ?? '');
        // append model query-string to url-param:
        url += '?' + encodeURIComponent(AppStateModel.getStateQueryString());

        // description
        url += '&text=' + encodeURIComponent(Sharer.OGmetaTags.description.getAttributeNode('content')?.value ?? '');

        // open new window/tab with Twitter intent
        const tgt = Sharer.getTarget(_X)

        if (tgt && tgt.name === _X) {
            window.open(tgt.endpoint + url, '_blank', Sharer._getWindowSpec(tgt));
        } else {
            LogUtil.error('sharing target not found')
        }

    }

    static getTarget(tgt: string): SharingTarget {
        return Sharer.data.targets.filter(target => target.name === tgt)[0] ?? {};
    }

    static set isActive(boolean) {
        Sharer._active = boolean;
    }

    static get isActive() {
        return Sharer._active;
    }
}

interface SharingTarget {
    name: string,
    endpoint: string,
    window: { [key: string]: string},
    icon: string
}
